import React from "react";
import { useLocation } from "react-router-dom";
import RootAccount from "container/account/RootAccount";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getQueryObjFromUrl } from "lib/urlQueryParser";

function AccountPage(props) {
  const location = useLocation();

  const query = getQueryObjFromUrl(location.search);

  return (
    <AppUpdateCheckpoint>
      <RootAccount query={query} />
    </AppUpdateCheckpoint>
  );
}

export default AccountPage;
